<template>
    <div class="ideal-payment-container">
        <div v-if="invoice">
            <b-card v-if="!['payment-created', 'payment-started', 'payment-planned'].includes(status)">
                <span class="error-message" v-translate>The direct iDEAL link is currently not setup up correctly. Please contact the sender or try paying manually.</span>
            </b-card>

            <b-row align-h="center">
                <b-col>
                    <h1 style="color: white" v-translate>Payment Request</h1>
                    <b-card>
                        <div class="ideal-logo-container">
                            <img class="ideal-logo" src="/static/images/iDEAL-logo.png"><span v-translate>iDEAL</span>
                        </div>
                        <hr>
                        <p class="field-container"><strong v-translate>Sent by:</strong> {{ company_profile.name }}</p>
                        <p class="field-container"><strong v-translate>Invoice Number:</strong> {{ invoice.number }}</p>
                        <p class="field-container"><strong v-translate>Invoice Amount:</strong> {{ invoice.total_amount | currency('EUR', 2)}}</p>
                        <p class="field-container"><strong v-translate>Amount Due:</strong> {{ amountToPay | currency('EUR', 2)}}</p>

                        <b-row align-h="center">
                            <GekkoButton 
                                v-if="amountToPay > 0"
                                :text="$gettext('Pay Now')" 
                                @click="checkoutUrl"
                                class="payment-button"
                            />
                        </b-row>
                    </b-card>
                </b-col>

                <b-col cols="9">
                    <div class="pdf-preview-wrap">
                        <iframe class="pdf-preview" v-if="invoice" :src="invoice.pdf_file"></iframe>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div v-if="!invoice && status !== 'unprocessable-entity' && !loading">
            <h1 v-translate>Oops this payment request does not seem to exist</h1>
            <div>
                <div v-translate>Please contact the company that send you this link and report that you received this broken link.</div>
            </div>
        </div>

        <div v-if="!invoice && status === 'unprocessable-entity' && !loading">
            <h1 v-translate>Invoice payment failed</h1>
            <div>
                <div v-translate>We're sorry, but your payment couldn't be processed. Please double-check your payment information and try again. If the issue persists, contact {{ this.company_profile.name }}.</div>
            </div>
        </div>
    </div>
</template>

<script>
import IdealPaymentService from '@/store/services/idealpayment.service.js'
import GekkoButton from '@/components/GekkoButton'

export default {
    name: "MolliePaymentStart",
    components: {GekkoButton},
    data() {
        return {
            status: null,
            invoice: null,
            company_profile: null,
            loading: true,
            amountToPay: 0
        }
    },
    created() {
        let uuid = this.$route.params['uuid']

        IdealPaymentService.generateRootlinePayment(uuid).then((response) => {
            if (response.status !== 204) {
                this.amountToPay = response.data.amount_cents / 100
                if (this.amountToPay <= 1) // min amount is 1 euro for rootline
                    this.$router.push({ name: 'RootlinePaymentComplete',  params: { uuid: uuid} })
                this.invoice = response.data.invoice
                this.company_profile = response.data.company_profile
                this.status = response.data.status
            } else {
                this.$router.push({ name: 'RootlinePaymentComplete',  params: { uuid: uuid} })
            }
            this.loading = false
        }).catch((error) => {
            if (error.status === 422) {
                this.status = 'unprocessable-entity'
                this.company_profile = error.data.company_profile
            }
            this.loading = false
        })
    },
    methods: {
        checkoutUrl() {
            let uuid = this.$route.params['uuid']

            IdealPaymentService.rootlineCheckoutUrl(uuid).then((response) => {
                window.location.href = response.data.url
            }).catch((error) => { // redirects if no errors
                if (error.status === 404) {
                    this.$store.commit('setAlert', {
                        title: this.$gettext('Error'),
                        text: this.$gettext('Payment not found'),
                        variant: 'danger',
                        duration: 4
                    })
                } else {
                    this.$store.commit('setAlert', {
                        title: this.$gettext('Error'),
                        text: this.$gettext('Error creating payment link: Please contact the sender or try paying manually.'),
                        variant: 'danger',
                        duration: 4
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.pdf-preview-wrap {
    padding: 0;
    padding-top: 1rem;
    aspect-ratio: 1/1.4142;
    max-width: 800px;
    margin: 0 auto;
}

.pdf-preview {
    height: 100%;
    width: 100%;
    border: 0;
    transition: opacity 0.3s ease;
}

.error-message {
    color: #810911;
    font-style: italic;
}

.ideal-logo {
    width: 45px;
}

.field-container {
    margin-bottom: 10px;
}

.ideal-payment-container {
    padding: 1rem;
    color: #ffffff;

    .row {
        color: #000000;
    }
}

.ideal-logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.payment-button {
    width: 92%;
    margin-bottom: 1rem;
    margin-top: 1rem;
}
</style>